'use strict';

var lightMobile375$3 = require('./packages/aviary-tokens/dist/fullscript/web/light-mobile375.cjs');
var darkMobile375$2 = require('./packages/aviary-tokens/dist/fullscript/web/dark-mobile375.cjs');
var lightMobile375$4 = require('./packages/aviary-tokens/dist/fullscript/native/light-mobile375.cjs');
var darkMobile375$3 = require('./packages/aviary-tokens/dist/fullscript/native/dark-mobile375.cjs');
var lightTablet834$2 = require('./packages/aviary-tokens/dist/fullscript/web/light-tablet834.cjs');
var darkTablet834$1 = require('./packages/aviary-tokens/dist/fullscript/web/dark-tablet834.cjs');
var lightDesktop1024$2 = require('./packages/aviary-tokens/dist/fullscript/web/light-desktop1024.cjs');
var darkDesktop1024$1 = require('./packages/aviary-tokens/dist/fullscript/web/dark-desktop1024.cjs');
var lightDesktop1280$2 = require('./packages/aviary-tokens/dist/fullscript/web/light-desktop1280.cjs');
var darkDesktop1280$1 = require('./packages/aviary-tokens/dist/fullscript/web/dark-desktop1280.cjs');
var lightMobile375$5 = require('./packages/aviary-tokens/dist/emerson/web/light-mobile375.cjs');
var lightTablet834$3 = require('./packages/aviary-tokens/dist/emerson/web/light-tablet834.cjs');
var lightDesktop1024$3 = require('./packages/aviary-tokens/dist/emerson/web/light-desktop1024.cjs');
var lightDesktop1280$3 = require('./packages/aviary-tokens/dist/emerson/web/light-desktop1280.cjs');
var light$2 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/light.cjs');
var dark$2 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/dark.cjs');
var light$3 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/light.cjs');
var dark$3 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/dark.cjs');
var emerson$1 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/emerson.cjs');
var lightDS3$1 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/lightDS3.cjs');

var lightMobile375 = lightMobile375$3.lightMobile375;
var darkMobile375 = darkMobile375$2.darkMobile375;
var lightMobile375$1 = lightMobile375$4.lightMobile375;
var darkMobile375$1 = darkMobile375$3.darkMobile375;
var lightTablet834 = lightTablet834$2.lightTablet834;
var darkTablet834 = darkTablet834$1.darkTablet834;
var lightDesktop1024 = lightDesktop1024$2.lightDesktop1024;
var darkDesktop1024 = darkDesktop1024$1.darkDesktop1024;
var lightDesktop1280 = lightDesktop1280$2.lightDesktop1280;
var darkDesktop1280 = darkDesktop1280$1.darkDesktop1280;
var lightMobile375$2 = lightMobile375$5.lightMobile375;
var lightTablet834$1 = lightTablet834$3.lightTablet834;
var lightDesktop1024$1 = lightDesktop1024$3.lightDesktop1024;
var lightDesktop1280$1 = lightDesktop1280$3.lightDesktop1280;
var light = light$2.light;
var dark = dark$2.dark;
var light$1 = light$3.light;
var dark$1 = dark$3.dark;
var emerson = emerson$1.emerson;
var lightDS3 = lightDS3$1.lightDS3;

/**
 * Naming convention:
 *
 * "web" - Tokens used on a web browser
 * "native" - Tokens used on a native app (iOS or Android)
 *
 * "light" - Tokens used on a light theme
 * "dark" - Tokens used on a dark theme
 *
 * "mobile" - Tokens used on a mobile device (could be on a web browser or native app)
 * "desktop" - Tokens used on a desktop device (web browser only)
 */ // DS5 Fullscript
const fullscriptWebDs3 = {
    ...lightDS3,
    ds5: lightDesktop1024
};
const fullscriptWebLight = {
    mobile375: {
        ...light,
        ds5: lightMobile375
    },
    tablet834: {
        ...light,
        ds5: lightTablet834
    },
    desktop1024: {
        ...light,
        ds5: lightDesktop1024
    },
    desktop1280: {
        ...light,
        ds5: lightDesktop1280
    }
};
const fullscriptWebDark = {
    mobile375: {
        ...dark,
        ds5: darkMobile375
    },
    tablet834: {
        ...dark,
        ds5: darkTablet834
    },
    desktop1024: {
        ...dark,
        ds5: darkDesktop1024
    },
    desktop1280: {
        ...dark,
        ds5: darkDesktop1280
    }
};
({
    ...light$1,
    ds5: lightMobile375$1
});
({
    ...dark$1,
    ds5: darkMobile375$1
});
const emersonWeb = {
    mobile375: {
        ...emerson,
        ds5: lightMobile375$2
    },
    tablet834: {
        ...emerson,
        ds5: lightTablet834$1
    },
    desktop1024: {
        ...emerson,
        ds5: lightDesktop1024$1
    },
    desktop1280: {
        ...emerson,
        ds5: lightDesktop1280$1
    }
};

var emersonWeb_1 = emersonWeb;
var fullscriptWebDark_1 = fullscriptWebDark;
var fullscriptWebDs3_1 = fullscriptWebDs3;
var fullscriptWebLight_1 = fullscriptWebLight;

exports.emersonWeb = emersonWeb_1;
exports.fullscriptWebDark = fullscriptWebDark_1;
exports.fullscriptWebDs3 = fullscriptWebDs3_1;
exports.fullscriptWebLight = fullscriptWebLight_1;
//# sourceMappingURL=index.cjs.map
